

<!--header new -->
<ng-container *ngIf="currentJob === 'learn'">
<div [ngClass]="isPublicProfileRoute ? 'bg-white' : ''">
  <nav class="flex justify-center transition-all duration-300 ease-in-out"
    [ngClass]="isPublicProfileRoute ? 'bg-white md:sticky md:top-0 z-50 py-2 max-w-5xl mx-auto px-6' : (isScrolled ? 'bg-transparent md:fixed md:top-0 md:px-4' : 'bg-transparent md:fixed md:top-4 md:px-4')">
      <div id="header-class" [ngClass]="[{'mobile-search-active': showMobileSearchInput}, headerMaxWidthClass, isScrolled ? 'header-scrolled' : '']" class="header-class headerMaxWidthClass flex items-center justify-between w-full h-14 pl-3 pr-2 transition-all duration-300 ease-in-out md:rounded-full" [ngStyle]="isScrolled ? {'background': 'rgba(255,255,255,0.85)', 'backdrop-filter': 'blur(16px)', '-webkit-backdrop-filter': 'blur(16px)', 'box-shadow': '0 2px 24px rgba(0,0,0,0.10)', 'border-radius': '0'} : {'background': 'rgb(255,255,255)', 'box-shadow': '0 2px 12px rgba(0,0,0,0.06)', 'border-radius': ''}">      <!-- Logo y main -->
      <div class="flex items-center gap-5 min-w-0 hide-on-mobile-search" [class.flex-1]="!showSearchContainer">
         <!-- Botón hamburguesa menu -->
        <button id="menu-btn" class="md:hidden text-gray-500 focus:outline-none" style="display:none;">
          <i class="fa-solid fa-bars text-xl hover:text-secondary-500"></i>
        </button>

        <!--
          [MOBILE BACK BUTTON] Flecha de retroceso visible solo en móvil (block md:hidden).
          Navega a la página anterior usando Location.back().
          No se muestra en la vista de inicio (overview) porque no hay sección anterior relevante.
        -->
        <button
          *ngIf="!router.url.includes('overview')"
          (click)="goBack()"
          class="block md:hidden flex-shrink-0 p-1.5 -ml-1 text-gray-500 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Volver atrás">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

         <!-- Logo -->
        <a class="shrink-0">
          <img [src]="companyLogo" alt="CompanyName" alt="Griky" class="h-8 cursor-pointer"  [ngClass]="{'pointer-events-none': !canNavigate}"
          [routerLink]="['/', currentJob, company?.slug]" (click)="closePlayer()">
        </a>
        <div class="hidden md:block w-px h-6 bg-gray-200"></div>

        <!-- Menu principal (Desktop) -->
        <div class="hidden md:flex items-center gap-2"  [ngClass]="{'pointer-events-none': !canNavigate}">
          <a [routerLink]="['/learn', company?.slug, 'overview']" (click)="closePlayer()" [routerLinkActive]="'active'" class="tab-a items-navbar px-4 py-2 text-sm font-medium text-gray-700">{{'player.course.start' | translate}}</a>
          <a [routerLink]="['/learn', company?.slug, 'catalogue', 'all']" (click)="closePlayer()"
            [routerLinkActive]="'active'" class="px-4 py-2 text-sm font-medium tab-a items-navbar relative text-gray-700">{{'words.catalogue' | translate}}</a>
          <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()" [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }" class="px-4 py-2 text-sm font-medium text-gray-700 tab-a items-navbar">{{'words.my-courses' | translate}}</a>
        </div>
      </div>

      <!-- Buscador inline Desktop (Predictive) -->
      <div *ngIf="showSearchContainer" class="hidden md:flex flex-1 mx-4 relative" [clickOutside]="[]" (onClickOutside)="closePredictiveDropdown()">
        <div class="flex items-center h-10 gap-2 w-full bg-gray-50 rounded-full pl-4 pr-3  shadow-sm border border-solid input-search-home animate-in fade-in slide-in-from-left-4 duration-300">
          <svg   fill="none" stroke="currentColor" viewBox="0 0 24 24" class="text-gray-500  w-4 h-4"><path  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
          <input
            type="text"
            [value]="predictiveQuery"
            (input)="onPredictiveInput($any($event.target).value)"
            (keydown.enter)="onPredictiveEnter()"
            (keydown.escape)="closeDesktopSearch()"
            [placeholder]="'words.would-like-to-learn' | translate"
            class="flex-1 min-w-0 bg-transparent border-none outline-none text-sm font-normal text-gray-700 placeholder-gray-400"
            autocomplete="off"
            #predictiveInput
          />
          <div *ngIf="isLoadingPredictive" class="flex-shrink-0 ml-2">
         <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-sm"></i>
          </div>
          <button *ngIf="predictiveQuery.length > 0" (click)="onPredictiveInput(''); predictiveInput.value = ''" class="flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 flex-shrink-0 rounded-full w-6 h-6 transition-colors">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-3.5 h-3.5"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
          <button (click)="closeDesktopSearch()" class="flex justify-center text-gray-500 hover:bg-gray-100 flex-shrink-0 rounded-full w-6 transition-colors">
            <i class="icon icon-arrow-ios-right"></i>
          </button>
        </div>
        <!-- Dropdown predictivo -->
        <div *ngIf="showPredictiveDropdown"
          class="absolute top-12 left-0 right-0 bg-white shadow-xl rounded-lg z-[9999] overflow-hidden border border-gray-100">

          <!-- Hint: escribe más caracteres -->
          <div *ngIf="predictiveQuery.trim().length < 3 && predictiveQuery.trim().length > 0"
            class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
            <i class="fa-solid fa-magnifying-glass text-gray-300 text-xs"></i>
            <span>Escribe al menos 3 caracteres para buscar…</span>
          </div>

          <!-- Cargando -->
          <div *ngIf="isLoadingPredictive && predictiveQuery.trim().length >= 3"
            class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
            <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
            <span>Buscando…</span>
          </div>

          <!-- Sin resultados -->
          <div *ngIf="!isLoadingPredictive && predictiveResults.length === 0 && predictiveQuery.trim().length >= 3"
            class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
            <i class="fa-solid fa-search-minus text-gray-300 text-xs"></i>
            <span>Sin resultados para "{{ predictiveQuery }}"</span>
          </div>

          <!-- Resultados -->
          <div *ngFor="let item of predictiveResults"
            class="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0"
            (click)="selectPredictiveResult(item)">
            <div class="relative w-10 h-8 rounded-sm flex-shrink-0 bg-gray-100 flex items-center justify-center overflow-hidden">
              <i class="fa-solid fa-book-open text-gray-400 text-sm"></i>
              <img
                *ngIf="getPredictivePicture(item)"
                [src]="getPredictivePicture(item)"
                class="absolute inset-0 w-full h-full object-cover"
                (error)="$any($event.target).style.display='none'"
              />
            </div>
            <div class="flex flex-col min-w-0 flex-1">
              <span class="text-sm font-medium text-gray-700 truncate">{{ item.data?.title || item.title }}</span>
              <span *ngIf="item.data?.skills?.[0]?.name" class="text-xs text-gray-400 truncate">{{ item.data.skills[0].name }}</span>
            </div>
            <span class="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0 whitespace-nowrap"
              [ngClass]="getContentTypeBadge(item.type).classes">
              {{ getContentTypeBadge(item.type).label | translate }}
            </span>
          </div>
        </div>
      </div>

        <label *ngIf="!canNavigate && !isPublicProfileRoute"
        class="text-xs text-red-600">{{'words.onboarding-warning' | translate}}</label>
      
        <!--Menu perfile-->
      <div class="flex items-center gap-2">
        <!-- Lupa Desktop -->
        <div class="hidden md:flex">
          <button *ngIf="showSearchBar && !showSearchContainer && !router.url.includes('contents')"
            (click)="openDesktopSearch()"
            class="p-2 text-gray-600 hover:bg-gray-50 rounded-full transition-colors"
            [ngClass]="{'pointer-events-none': !canNavigate}">
                         <svg [tooltip]="'words.search' | translate"  fill="none" stroke="currentColor" viewBox="0 0 24 24" class="text-gray-500  w-4 h-4"><path  stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
          </button>
        </div>
          <!-- BUSCADOR RESPONSIVE -->
        <!-- Lupa móvil: solo visible si el buscador NO está activo -->
        <div class="block md:hidden flex-shrink-0" *ngIf="!showMobileSearchInput && !router.url.includes('contents')">
          <button class="text-gray-600 px-3 py-2" (click)="toggleMobileSearch()"
            aria-label="Toggle search"
            [ngClass]="{'pointer-events-none': !canNavigate}">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="text-gray-500 w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </button>
        </div>

        <!-- Buscador móvil activo: ocupa todo el header -->
        <div *ngIf="showMobileSearchInput"
          class="flex md:hidden absolute inset-0 z-[100] bg-white h-20 items-center px-3 gap-2 animate-in fade-in duration-200">
          <!-- Flecha atrás: cierra el buscador sin resetear -->
          <button (click)="toggleMobileSearch()" class="flex-shrink-0 p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar buscador">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="text-gray-400 w-4 h-4 flex-shrink-0">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
          <input
            id="search-mobile-input"
            type="text"
            [value]="predictiveQuery"
            (input)="onPredictiveInput($any($event.target).value)"
            (keydown.enter)="onPredictiveEnter()"
            (keydown.escape)="closeMobileSearch()"
            [placeholder]="'words.would-like-to-learn' | translate"
            class="flex-1 min-w-0 bg-transparent border-none outline-none text-sm font-normal text-gray-700 placeholder-gray-400"
            autocomplete="off"
          />
          <div *ngIf="isLoadingPredictive" class="flex-shrink-0">
            <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-sm"></i>
          </div>
          <!-- X: resetea el texto y cierra el buscador -->
          <button (click)="closeMobileSearch()" class="flex-shrink-0 p-1 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" aria-label="Limpiar búsqueda">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>

          <!-- Dropdown predictivo móvil -->
          <div *ngIf="showPredictiveDropdown"
            class="absolute top-14 left-0 right-0 bg-white shadow-xl rounded-xl z-[9999] overflow-hidden border border-gray-100 mx-2">

            <!-- Hint: escribe más caracteres -->
            <div *ngIf="predictiveQuery.trim().length < 3 && predictiveQuery.trim().length > 0"
              class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
              <i class="fa-solid fa-magnifying-glass text-gray-300 text-xs"></i>
              <span>Escribe al menos 3 caracteres para buscar…</span>
            </div>

            <!-- Cargando -->
            <div *ngIf="isLoadingPredictive && predictiveQuery.trim().length >= 3"
              class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
              <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
              <span>Buscando…</span>
            </div>

            <!-- Sin resultados -->
            <div *ngIf="!isLoadingPredictive && predictiveResults.length === 0 && predictiveQuery.trim().length >= 3"
              class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
              <i class="fa-solid fa-search-minus text-gray-300 text-xs"></i>
              <span>Sin resultados para "{{ predictiveQuery }}"</span>
            </div>

            <!-- Resultados -->
            <div *ngFor="let item of predictiveResults"
              class="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0"
              (click)="selectPredictiveResult(item); toggleMobileSearch()">
              <div class="relative w-10 h-8 rounded-sm flex-shrink-0 bg-gray-100 flex items-center justify-center overflow-hidden">
                <i class="fa-solid fa-book-open text-gray-400 text-sm"></i>
                <img
                  *ngIf="getPredictivePicture(item)"
                  [src]="getPredictivePicture(item)"
                  class="absolute inset-0 w-full h-full object-cover"
                  (error)="$any($event.target).style.display='none'"
                />
              </div>
              <div class="flex flex-col min-w-0 flex-1">
                <span class="text-sm font-medium text-gray-700 truncate">{{ item.data?.title || item.title }}</span>
                <span *ngIf="item.data?.skills?.[0]?.name" class="text-xs text-gray-400 truncate">{{ item.data.skills[0].name }}</span>
              </div>
              <span class="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0 whitespace-nowrap"
                [ngClass]="getContentTypeBadge(item.type).classes">
                {{ getContentTypeBadge(item.type).label | translate }}
              </span>
            </div>
          </div>
        </div>

          <!-- Notificaciones -->
        <ng-container>
          <div class="hidden md:flex">
            <button id="notifBtn" class="p-2  hover:bg-gray-50 rounded-full relative text-gray-600"
              [ngClass]="{'pointer-events-none': !canNavigate}">
              <svg [ngClass]="{ 'bell-animated': animateBell }" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bell w-[18px] h-[18px] text-muted-foreground"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path></svg>
           

              <span *ngIf="unreadCount > 0"
                class="absolute bg-red-500 text-white w-4 h-4 flex items-center justify-center rounded-full "
                style="top: 7px; left: 1.1rem; font-size: 10px !important;">
                {{ unreadCount }}
              </span>
            </button>
            <div id="notifPanel" [class.hidden]="!showNotificationsPanel" class="absolute z-100 "
              style="right: 30px; top:4rem;">
              <div style="width: 360px !important; max-width: 22rem !important;">
                <!-- header -->


                <div *ngIf="unreadCount === 0"
                  class="bg-white border-t py-4 rounded-lg gap-1 border-gray-100 flex flex-col items-center px-3 text-center relative overflow-hidden justify-center"
                  style="min-height: 120px !important;">
                  <!-- Ícono de fondo -->
                  <i class="fa-solid fa-bell-slash text-gray-300 text-[5rem] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  pointer-events-none"
                    style="opacity: .17 !important;"></i>
                  <!-- Texto encima del ícono -->
                  <p class="text-sm text-gray-700 font-medium  z-10 relative">
                    {{ "words.notifications" | translate }}
                  </p>
                  <p class="text-sm text-gray-500 z-10 relative">
                    {{ "words.no-notifications" | translate }}
                  </p>
                </div>


                <div *ngIf="unreadCount > 0"
                  class="bg-white border-t py-2 rounded-t-lg border-gray-100 flex px-3 justify-between">
                  <div class="flex justify-center items-center">
                    <p class="text-sm text-gray-700 font-semibold">
                      {{ "words.notifications" | translate }}
                    </p>
                  </div>
                  <div *ngIf="unreadCount > 1" class="flex justify-center items-center">
                    <button class="text-blue-500 text-xs" (click)="markAllAsRead()">
                      {{ "words.notifications.mark-all-as-read" | translate }}
                    </button>
                  </div>
                </div>
                <ul id="ulnotifPanel" class=" max-h-96 overflow-y-auto rounded-b-lg">
                  <li class="border-b " *ngFor="let notif of notifications">
                    <div *ngIf="!notif.read">
                      <div class=" p-3 shadow-sm rounded-b-lg"
                        style="background: linear-gradient(to bottom, #c0c0c01f, #ffffff);">
                        <!-- Título -->
                        <div class="flex justify-start items-center mb-2">
                          <h4 class="font-semibold text-sm text-gray-700">
                            {{notif.title || "words.notification-title" | translate}}
                          </h4>
                        </div>
                        <!-- Mensaje -->
                        <p *ngIf="notif.type === 'calendar-event-reminder'" class="text-xs text-gray-500 "
                          style="border-left: 2px solid #8080804d;padding-left: 1rem; margin-left: 0.5rem;">
                          {{"calendar.event-reminder-message-part1" | translate}}
                          {{ notif.extra.remaining_time }}
                          {{
                          "calendar.event-reminder-message-part2"
                          | translate
                          }}
                          {{ notif.message }}.
                          <span class="text-gray-700 my-2  font-semibold text-xs"> {{notif.extra.content_title}}</span>
                        </p>
                        <!-- Contenido adicional según tipo -->
                        <div class="my-2 text-sm text-gray-500" *ngIf="
                                            notif.type ===
                                                'calendar-event-reminder' &&
                                            notif.extra?.url">
                          <p>
                            <strong>
                              <a style="margin-left: 0.5rem !important;"
                                class="inline-block px-3 py-1 text-xs font-medium text-white bg-secondary rounded hover:inline-block hover:bg-secondary transition"
                                (click)="closePlayer()" [routerLink]="notif.extra.url">
                                {{"words.notifications.course" | translate}} </a>
                            </strong>
                          </p>
                        </div>
                        <div class="flex justify-between">
                          <h4 class=" text-xs text-gray-400 ">
                            {{ notif.createdAt | timeAgo }}
                          </h4>
                          <div class="flex justify-end items-center ">
                            <button *ngIf="!notif.read" class="text-xs text-blue-500 " (click)="markAsRead(notif.id)">
                              {{
                              "words.notifications.mark-as-read"
                              | translate
                              }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Botón Notificaciones RESPONSIVE -->
        <button id="notif-mobile-btn" class="md:hidden text-gray-600 focus:outline-none hide-on-mobile-search">
          <i class="fa-regular fa-bell text-lg text-gray-600" [ngClass]="{ 'bell-animated': animateBell }"></i>
          <span *ngIf="unreadCount > 0"
            class="absolute top-0 -right-1 bg-red-500 text-white w-3 h-3 flex items-center justify-center rounded-full text-[8px]">
            {{ unreadCount }}
          </span>
        </button>

        <!-- Panel Notificaciones Mobile -->
        <div id="notif-mobile-panel"
          class="hidden md:hidden fixed inset-0 bg-white z-50 shadow-lg p-6 animate-dropdown-enter">
          <div class="flex justify-between items-center gap-4 border-b pb-4 ">
            <!-- Título -->
            <div class="flex items-center justify-between w-full ">
              <div class="flex justify-center items-center">
                <p class="text-base text-gray-700 font-semibold">
                  {{ "words.notifications" | translate }}
                </p>
              </div>

              <!-- Solo mostrar si hay más de 1 no leída -->
              <div *ngIf="unreadCount > 1" class="flex justify-center items-center">
                <button class="text-blue-500 text-base" (click)="markAllAsRead()">
                  {{ "words.notifications.mark-all-as-read" | translate }}
                </button>
              </div>
            </div>

            <!-- Botón cerrar siempre visible -->
            <button id="close-notif-mobile" class="text-lg hover:text-secondary">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div [class.hidden]="!showNotificationsPanel" id="ulnotif-mobile-panel">
            <div *ngIf="unreadCount === 0"
              class="bg-white border-t py-6 rounded-lg gap-1 border-gray-100 flex flex-col items-center px-3 text-center">
              <i class="fa-solid fa-bell-slash text-gray-300 text-[5rem] absolute  top-1/5 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-10 pointer-events-none"
                style="opacity: .2 !important;top: 13rem;"></i>

              <p class="text-base text-gray-700 font-semibold">
                {{ "words.notifications" | translate }}
              </p>
              <p class="text-base text-gray-500">
                {{ "words.no-notifications" | translate }}
              </p>
            </div>


            <ul id="ulnotifMobilePanel" class=" max-h-96 overflow-y-auto rounded-b-lg">
              <li class="border-b " *ngFor="let notif of notifications">
                <div *ngIf="!notif.read">
                  <div class=" p-3 shadow-sm rounded-b-lg">
                    <!-- Título -->
                    <div class="flex justify-start items-center mb-2">
                      <h4 class="font-semibold text-sm text-gray-700">
                        {{notif.title || "words.notification-title" | translate}}
                      </h4>
                    </div>
                    <!-- Mensaje -->
                    <p *ngIf="notif.type === 'calendar-event-reminder'" class="text-xs text-gray-500 "
                      style="border-left: 2px solid #8080804d;padding-left: 1rem; margin-left: 0.5rem;">
                      {{"calendar.event-reminder-message-part1" | translate}}
                      {{ notif.extra.remaining_time }}
                      {{
                      "calendar.event-reminder-message-part2"
                      | translate
                      }}
                      {{ notif.message }}.
                      <span class="text-gray-700 my-2  font-semibold text-xs"> {{notif.extra.content_title}}</span>
                    </p>
                    <!-- Contenido adicional según tipo -->
                    <div class="my-2 text-sm text-gray-500" *ngIf="
                                            notif.type ===
                                                'calendar-event-reminder' &&
                                            notif.extra?.url">
                      <p>
                        <strong>
                          <a style="margin-left: 0.5rem !important;"
                            class="inline-block px-3 py-1 text-xs font-medium text-white bg-secondary rounded hover:inline-block hover:bg-secondary transition"
                            (click)="closePlayer()" [routerLink]="notif.extra.url">
                            {{"words.notifications.course" | translate}} </a>
                        </strong>
                      </p>
                    </div>
                    <div class="flex justify-between">
                      <h4 class=" text-xs text-gray-400 ">
                        {{ notif.createdAt | timeAgo }}
                      </h4>
                      <div class="flex justify-end items-center ">
                        <button *ngIf="!notif.read" class="text-xs text-blue-500 " (click)="markAsRead(notif.id)">
                          {{
                          "words.notifications.mark-as-read"
                          | translate
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

          <!-- Menú Perfil -->
        <div class="relative item-perfile hide-on-mobile-search">
           <button id="profile-btn" (click)="toggleProfileMenu($event)" class="flex items-center gap-3 pl-1 pr-3 py-1 bg-gray-50 hover:bg-gray-100 rounded-full border border-gray-100 transition">
                <msc-common-avatar class="w-8 h-8 rounded-full object-cover" (click)="profileOpen = true" cdkOverlayOrigin #profile="cdkOverlayOrigin"
              [label]="me?.name" [pictureURL]="me?.picture ? (me?.picture + '?size=64') : null">
            </msc-common-avatar>
          <span class="hidden md:inline text-sm font-semibold text-gray-600">{{ shortName }}</span>
          <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7"/></svg>
        </button>

          <!-- Menú desplegable de perfil (Desktop) -->
          <div id="profile-menu"
            class="absolute mt-2 w-60 bg-white shadow-xl rounded-lg  hidden z-[999999] border border-gray-100"
            style="left: -3.5rem;">
            <!-- Header del perfil -->
            <div class="px-4 py-3 border-b border-gray-100 bg-gray-50 rounded-t-lg">
              <p class="text-sm font-medium text-gray-700">{{ shortName }}</p>
              <p class="text-xs text-gray-500 truncate">{{me?.email}}</p>
            </div>

            <!-- Sección 1 -->
            <div class="px-2 py-1">

              <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()"
                [ngClass]="{'pointer-events-none': !canNavigate}"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2">
                <i class="icon icon-book-open text-gray-500 text-base w-4 flex justify-center"></i> {{"words.my-courses"
                |
                translate}}</a>

                <!--Perfil academico-->

       
              <a *ngIf="academicProfileEnabled"
                [routerLink]="['/learn', company?.slug, 'academy', 'details']"
                (click)="closePlayer()" [ngClass]="{'pointer-events-none': !canNavigate}"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2">
                  <svg class="text-gray-500 text-xs flex justify-center" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap w-4 h-4 text-muted-foreground"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path><path d="M22 10v6"></path><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path></svg>
                {{'words.academy-profile' | translate}}
              </a>

              <a [routerLink]="['/learn', company?.slug, 'onementor']" (click)="closePlayer()"
                [ngClass]="{'pointer-events-none': !canNavigate}"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"
                *ngIf="hasOneMentorEnabled">
                <i class="fa-regular fa-paper-plane text-gray-500 text-xs  flex justify-center"></i>
                {{'words.boots-your-profile'
                |
                translate}}</a>
            </div>
            <!-- Sección 2 -->
            <div class="border-t border-gray-100 mx-3" *ngIf="showChangeUserRole || showChangeUserCompany"></div>
            <div class=" px-2 py-1">
              <!-- Cambiar de rol -->
              <div class="relative group">
                <div [ngClass]="{
                    'pointer-events-none': !canNavigate,
                    'invisibleOptions': !showChangeUserRole
                  }"
                  class="items-navbar flex items-center justify-between px-3 py-1.5 text-gray-500 text-sm rounded-md cursor-pointer transition-colors duration-150"
                  id="change-role-btn">
                  <div class="flex items-center gap-2">
                    <i class="icon-credit-card icon text-base w-4 flex justify-center"></i>
                    <span class="text-gray-500">{{'words.change-rol' | translate}}</span>
                  </div>
                  <i class="fas fa-chevron-right text-xs flex justify-center"></i>
                </div>
                <div
                  class="absolute right-full top-0 mr-1 w-56 bg-white shadow-lg rounded-md py-2 hidden  group-focus-within:block z-[10000] border border-gray-100 dropdown-menu"
                  id="change-role-menu">
                  <div *ngIf="roles.length > 0" class="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                    {{'words.select-rol'
                    | translate}}</div>
                  <div _ngcontent-pug-c114="" class="border-t border-gray-100 mx-3" *ngIf="roles.length > 0"></div>
                  <ul class='menu tab' *ngIf="roles.length > 0">
                    <li class="tabs">
                      <ng-container *ngFor="let role of roles">
                        <div class="items-navbar block px-4 py-1.5 text-gray-500 text-sm cursor-pointer"
                          *ngIf="!role.hidden" [routerLink]="role.routerLink" [routerLinkActive]="'active'"
                          (click)="role.customNavParams ? navigateTo(role.customNavParams) : null">
                          <span class="text-gray-500">{{ role.label | translate }}</span>
                        </div>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Cambiar de empresa -->
              <div class="relative group" [ngClass]="{
                    'pointer-events-none': !canNavigate,
                    'invisibleOptions': !showChangeUserCompany
                  }">
                <div
                  class="items-navbar flex items-center justify-between px-3 py-1.5 text-gray-500 text-sm rounded-md cursor-pointer transition-colors duration-150"
                  id="change-company-btn">
                  <div class="flex items-center gap-2">
                    <i class="icon icon-layers text-base w-4 flex justify-center"></i>
                    <span class="text-gray-500">{{'words.change-company' | translate}}</span>
                  </div>
                  <i class="fas fa-chevron-right text-xs"></i>
                </div>

                <div
                  class="absolute right-full top-0 mr-1 min-w-[250px] bg-white shadow-lg rounded-md py-2 hidden  group-focus-within:block z-[10000] border border-gray-100 dropdown-menu"
                  id="change-company-menu">
                  <div class="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                    {{'studio.section-content.select-company' | translate}}
                  </div>

                  <div class="border-t border-gray-100 mx-3"></div>

                  <!-- Buscador -->
                  <div class="px-3 py-2" (click)="$event.stopPropagation()">
                    <div
                      class="w-full flex items-center border border-gray-200 rounded-md shadow-sm bg-white overflow-hidden">
                      <input type="text" [placeholder]="'placeholder.search' | translate"
                        class="flex-grow px-2 py-1 text-sm font-[400] focus:outline-none" [(ngModel)]="companySearch"
                        (ngModelChange)="filterAvailableCompanies($event)" />
                      <button class="p-2">
                        <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Empresas -->
                  <div id="companiesList" class="max-h-60 overflow-y-auto">
                    <div class="company-item flex" *ngFor="let availableCompany of availableCompanies"
                      [class.active]="availableCompany.id === company.id"
                      (click)="onSelectCompany(availableCompany); companiesPickerOpen = false">
                      <i *ngIf="!availableCompany.logo" class="icon icon-company-building"></i>
                      <div class="company-item__logo" *ngIf="availableCompany.logo"
                        [style.backgroundImage]="'url(' + availableCompany.logo + '?size=512' + ')'"></div>
                      <div>
                        <a class="items-navbar block px-4 py-1.5 text-gray-500 text-sm">{{ availableCompany.title |
                          translate }}</a>
                        <!--<small class="text-black-300" [innerHTML]="availableCompany.subtitle | translate"></small>-->
                      </div>
                      <div class="company-item__state" *ngIf="availableCompany.id === company.id">
                        <i class=" fa-solid fa-check text-green-500 text-xs"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección 3 -->
            <div class="border-t border-gray-100 mx-3"></div>
            <div class="px-2 py-1">
              <!--
              <a [routerLink]="['/learn', company?.slug, 'communities']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-users text-gray-500 text-xs w-4"></i> {{'words.groups' | translate}}</a>
              <a [routerLink]="['/learn', company?.slug, 'integrations']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-window-restore text-gray-500 text-xs w-4"></i> {{'words.my-applications' |
                translate}}</a>-->
              <a [routerLink]="['/learn', company?.slug, 'contents', 'saved']" (click)="closePlayer()"
                [ngClass]="{'pointer-events-none': !canNavigate}"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="icon icon-bookmark text-gray-500 text-sm w-4 flex justify-center"></i> {{'word-saved' |
                translate}}</a>
            </div>

            <!-- Sección 4 -->
            <div class="border-t border-gray-100 mx-3"></div>
            <div class="px-2 py-1 pb-3">
              <!-- Configuración: submenú con Mi perfil / Mi configuración / Mi suscripción (igual a /account/settings) -->
              <div class="relative group" [ngClass]="{'pointer-events-none': !canNavigate}">
                <div
                  class="items-navbar flex items-center justify-between px-3 py-1.5 text-gray-500 text-sm rounded-md cursor-pointer transition-colors duration-150"
                  id="account-settings-btn">
                  <div class="flex items-center gap-2">
                    <i class="icon newicon-icon-settings text-gray-500 text-xs font-semibold w-4 flex justify-center"></i>
                    <span class="text-gray-500">{{'words.settings' | translate}}</span>
                  </div>
                  <i class="fas fa-chevron-right text-xs flex justify-center"></i>
                </div>
                <div
                  class="absolute right-full top-0 mr-1 w-56 bg-white shadow-lg rounded-md py-2 hidden group-focus-within:block z-[10000] border border-gray-100 dropdown-menu"
                  id="account-settings-menu">
                  <a routerLink="/account/profile" (click)="closePlayer()"
                    class="items-navbar block px-4 py-1.5 text-gray-500 text-sm cursor-pointer">
                    <span class="text-gray-500">{{'words.profile-edit' | translate}}</span>
                  </a>
                  <a routerLink="/account/settings" (click)="closePlayer()"
                    class="items-navbar block px-4 py-1.5 text-gray-500 text-sm cursor-pointer">
                    <span class="text-gray-500">{{'words.my-settings' | translate}}</span>
                  </a>
                  <a routerLink="/account/subscription" (click)="closePlayer()"
                    class="items-navbar block px-4 py-1.5 text-gray-500 text-sm cursor-pointer">
                    <span class="text-gray-500">{{'words.my-subscription' | translate}}</span>
                  </a>
                </div>
              </div>
              <!--
                  <a href="#"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-question-circle text-gray-500 text-xs w-4"></i> {{'header.profile.help' |
                translate}}</a>-->
              <a (click)="logout()"
                class="block px-3 py-1.5 text-red-500 hover:bg-red-50 text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-sign-out-alt text-red-500 text-xs w-4 flex justify-center"></i> {{'auth.logout' |
                translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

     <!-- RESPONSIVEE -->
    <!-- Menú principal móvil OCULTO STYLO HAMBURGUESA -->
    <div id="mobile-menu" class="hidden md:hidden fixed inset-0 bg-white z-50 shadow-lg p-6"
      [ngClass]="{'pointer-events-none': !canNavigate}" style="display:none;">
      <!-- head -->
      <div class="flex justify-between items-center w-full border-b border-gray-200 pb-4 ">
        <img [src]="companyLogo" alt="CompanyName" class="h-6 w-auto max-w-full object-contain sm:h-8 cursor-pointer"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          [routerLink]="['/', currentJob, company?.slug]" (click)="closePlayer()">
        <button id="close-menu" class="text-lg hover:text-secondary">
          <i class="fa-solid fa-xmark hover:text-secondary"></i>
        </button>
      </div>
      <div class="main-div mt-4 gap-2 flex flex-col items-start justify-start">
        <a [routerLink]="['/learn', company?.slug, 'overview']" (click)="closePlayer()" [routerLinkActive]="'active'"
          class="tab-a-sm tab-a items-navbar relative text-gray-700  text-sm font-medium py-2 px-4 ">{{'words.start'
          |
          translate}}</a>
        <a [routerLink]="['/learn', company?.slug, 'catalogue', 'all']" (click)="closePlayer()"
          [routerLinkActive]="'active'"
          class="tab-a-sm tab-a items-navbar relative text-gray-700  text-sm font-medium py-2 px-4 ">
          {{ "words.catalogue" |
          translate
          }}</a>
        <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()" [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          class="tab-a-sm tab-a items-navbar relative text-gray-700  text-sm font-medium py-2 px-4 ">{{"words.my-courses"
          |
          translate}}</a>
      </div>
    </div>

    <!-- Menú principal móvil VISIBLE BARRA INFERIOR-->
    <div id="mobile-top-bar" style="  border-top: 1.5px solid var(--v2-color-secondary-200) !important;"
      class="rounded-t-xl  fixed bottom-0 left-0 right-0 z-50 bg-white shadow-md flex justify-around items-center h-14 sm:h-16 px-4 "
      [ngClass]="{'pointer-events-none': !canNavigate}">

      <!-- Icono Inicio -->
      <a [routerLink]="['/learn', company?.slug, 'overview']" (click)="closePlayer()"
        [routerLinkActive]="'text-secondary'"
        class="flex flex-col items-center justify-center text-xs text-gray-500 hover:text-secondary">
        <i class="fa-solid fa-house text-lg mb-1 text-current"></i>
        {{ 'words.start' | translate }}
      </a>

      <!-- Icono Catálogo -->
      <a [routerLink]="['/learn', company?.slug, 'catalogue', 'all']" (click)="closePlayer()"
        [routerLinkActive]="'text-secondary'"
        class="flex flex-col items-center justify-center text-xs text-gray-500 hover:text-secondary">
        <i class="far fa-folder-open text-lg mb-1 text-current"></i>
        {{ 'words.catalogue' | translate }}
      </a>

      <!-- Icono Mis Cursos -->
      <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()"
        [routerLinkActive]="'text-secondary'" [routerLinkActiveOptions]="{ exact: true }"
        class="flex flex-col items-center justify-center text-xs text-gray-500 hover:text-secondary">
        <i class="fa-solid fa-graduation-cap text-lg mb-1 text-current"></i>
        {{ 'words.my-courses' | translate }}
      </a>
    </div>

    <!-- Menú de perfil responsive (móvil) -->
    <div id="mobile-menu-perfile" class="hidden md:hidden fixed inset-0 bg-white z-50 shadow-lg p-6">
      <div class="flex justify-between items-center gap-4">
        <div class="px-4 py-3 w-full justify-start  bg-gray-50 rounded-lg">
          <p class="text-sm font-medium text-gray-700">{{ shortName }}</p>
          <p class="text-xs text-gray-500 truncate">{{me?.email}}</p>
        </div>
        <button id="close-profile-menu" class="text-lg hover:text-secondary">
          <i class="fa-solid fa-xmark hover:text-secondary"></i>
        </button>
      </div>
      <div class="main-div mt-4 border-t gap-2 flex flex-col items-start pt-4 ">
        <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2">
          <i class="icon icon-book-open text-gray-500 text-sm w-4 flex justify-center"></i>
          {{"words.my-courses"
          | translate}}</a>

        <a *ngIf="academicProfileEnabled"
          [routerLink]="['/learn', company?.slug, 'academy', 'details']"
          (click)="closePlayer()" [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2">   
          <svg class="text-gray-500 text-xs flex justify-center" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap w-4 h-4 text-muted-foreground"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path><path d="M22 10v6"></path><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path></svg>
          {{'words.academy-profile' | translate}}
        </a>

        <a [routerLink]="['/learn', company?.slug, 'onementor']" (click)="closePlayer()"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2"
          *ngIf="hasOneMentorEnabled">
          <i class="fa-regular fa-paper-plane text-gray-500 text-xs  flex justify-center"></i>
          {{'words.boots-your-profile' |
          translate}}</a>

        <!-- Cambiar de Rol (Mobile) -->
        <div class="w-full" [ngClass]="{
                    'invisibleOptions': !showChangeUserRole
                  }">
          <button (click)="showRoleMenuMobile = !showRoleMenuMobile"
            class="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-600 font-medium cursor-pointer transition-colors duration-150">
            <div class="flex items-center gap-2">
              <i class="icon icon-credit-card text-sm text-gray-500 w-4"> </i>
              <span>{{ 'words.change-rol' | translate }}</span>
            </div>
            <i class="fas"
              [ngClass]="{'fa-chevron-down': !showRoleMenuMobile, 'fa-chevron-up': showRoleMenuMobile}"></i>
          </button>

          <div *ngIf="showRoleMenuMobile" class="pl-4 bg-gray-50 rounded-lg">
            <div class="pr-4">
              <ul class="w-full">
                <li *ngFor="let role of roles">
                  <div
                    class="flex items-center justify-between px-2 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md "
                    *ngIf="!role.hidden" [routerLink]="role.routerLink"
                    (click)="role.customNavParams ? navigateTo(role.customNavParams) : null; closeDropdown(mobileMenuPerfile)">
                    {{ role.label | translate }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Cambiar de Empresa (Mobile) -->
        <div class="w-full " *ngIf="availableCompanies.length > 1">
          <button (click)="showCompanyMenuMobile = !showCompanyMenuMobile"
            class="w-full flex items-center justify-between px-4 py-2 text-sm text-gray-700 font-medium transition-colors duration-150">
            <div class="flex items-center gap-2">
              <i class="icon icon-layers text-gray-500 text-sm w-4 flex justify-center"></i>
              <span>{{ 'words.change-company' | translate }}</span>
            </div>
            <i class="fas"
              [ngClass]="{'fa-chevron-down': !showCompanyMenuMobile, 'fa-chevron-up': showCompanyMenuMobile}"></i>
          </button>

          <div *ngIf="showCompanyMenuMobile" class="pl-4 bg-gray-50  rounded-lg">
            <!-- Buscador -->
            <div class="py-2 pr-4">
              <div class="flex items-center border border-gray-200 rounded-md shadow-sm bg-white overflow-hidden">
                <input type="text" [placeholder]="'placeholder.search' | translate"
                  class="flex-grow px-2 py-1 text-sm focus:outline-none" [(ngModel)]="companySearch"
                  (ngModelChange)="filterAvailableCompanies($event)" />
                <button class="p-2">
                  <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                </button>
              </div>
            </div>

            <!-- Lista de empresas -->
            <div class="max-h-60 overflow-y-auto pr-4">
              <div *ngFor="let availableCompany of availableCompanies"
                class="flex items-center justify-between px-2 py-2 text-sm text-gray-600 cursor-pointer hover:bg-gray-100 rounded-md "
                [class.font-semibold]="availableCompany.id === company.id"
                (click)="onSelectCompany(availableCompany); closeDropdown(mobileMenuPerfile)">
                <span>{{ availableCompany.title | translate }}</span>
                <i *ngIf="availableCompany.id === company.id" class="fa-solid fa-check text-green-500 text-xs"></i>
              </div>
            </div>
          </div>
        </div>

        <a [routerLink]="['/learn', company?.slug, 'contents', 'saved']" (click)="closePlayer()"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2">
          <i class="icon icon-bookmark text-gray-500 text-sm w-4 flex justify-center"></i>
          {{'word-saved' | translate}}</a>

        <a routerLink="/account/subscription"
          (click)="closePlayer()"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2"
          *ngIf="hasActiveSubscription">
          <i class="icon icon-credit-card text-gray-500 text-sm w-4 flex justify-center"></i>
          {{'words.my-subscription' | translate}}</a>
        <a routerLink="/account/settings"
          [ngClass]="{'pointer-events-none': !canNavigate}"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2">
          <i class="icon icon-settings text-gray-500 text-sm w-4 flex justify-center"></i>
          {{'words.settings' | translate}}</a>

        <a (click)="logout()"
          class="tab-a-sm tab-a items-navbar justify-start relative text-gray-700  text-sm font-medium py-2 px-4 gap-2">
          <i class="fas fa-sign-out-alt text-gray-500 text-sm w-4 flex justify-center"></i>{{'auth.logout' |
          translate}}</a>
      </div>
    </div>

    <!--
      [MOBILE SCROLL SEARCH] Barra de búsqueda predictiva que aparece en móvil
      al hacer scroll > 120px. Solo visible en pantallas pequeñas (md:hidden).
      Solo se activa en la vista overview. Se coloca DENTRO del <nav> para que
      baje con el header como una sola unidad al hacer scroll (no es fixed independiente).
    -->
    <div
      *ngIf="showMobileScrollSearch && !showMobileSearchInput && (router.url.includes('overview') || router.url.includes('catalogue'))"
      class="md:hidden w-full px-4 pb-3 relative mobile-scroll-search-bar"
      [clickOutside]="[]"
      (onClickOutside)="showPredictiveDropdown && closePredictiveDropdown()">

      <!-- Input de búsqueda móvil -->
      <div class="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-4 py-2 shadow-sm">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4 text-gray-400 flex-shrink-0">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <input
          type="text"
          [value]="predictiveQuery"
          (input)="onPredictiveInput($any($event.target).value)"
          (keydown.enter)="onPredictiveEnter()"
          (keydown.escape)="closePredictiveDropdown()"
          [placeholder]="'words.would-like-to-learn' | translate"
          class="flex-1 min-w-0 bg-transparent border-none outline-none text-sm text-gray-700 placeholder-gray-400"
          autocomplete="off"
        />
        <!-- Spinner de carga -->
        <div *ngIf="isLoadingPredictive" class="flex-shrink-0">
          <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
        </div>
        <!-- Botón limpiar texto -->
        <button *ngIf="predictiveQuery.length > 0"
          (click)="onPredictiveInput('')"
          class="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-3 h-3">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Dropdown predictivo del buscador móvil -->
      <div *ngIf="showPredictiveDropdown"
        class="absolute left-4 right-4 top-full mt-1 bg-white shadow-xl rounded-xl z-[9999] overflow-hidden border border-gray-100">

        <!-- Hint: escribe más caracteres -->
        <div *ngIf="predictiveQuery.trim().length < 3 && predictiveQuery.trim().length > 0"
          class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
          <i class="fa-solid fa-magnifying-glass text-gray-300 text-xs"></i>
          <span>Escribe al menos 3 caracteres para buscar…</span>
        </div>

        <!-- Estado de carga -->
        <div *ngIf="isLoadingPredictive && predictiveQuery.trim().length >= 3"
          class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
          <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
          <span>Buscando…</span>
        </div>

        <!-- Sin resultados -->
        <div *ngIf="!isLoadingPredictive && predictiveResults.length === 0 && predictiveQuery.trim().length >= 3"
          class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
          <i class="fa-solid fa-search-minus text-gray-300 text-xs"></i>
          <span>Sin resultados para "{{ predictiveQuery }}"</span>
        </div>

        <!-- Lista de resultados predictivos -->
        <div *ngFor="let item of predictiveResults"
          class="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0"
          (click)="selectPredictiveResult(item)">
          <div class="relative w-10 h-8 rounded-sm flex-shrink-0 bg-gray-100 flex items-center justify-center overflow-hidden">
            <i class="fa-solid fa-book-open text-gray-400 text-sm"></i>
            <img
              *ngIf="getPredictivePicture(item)"
              [src]="getPredictivePicture(item)"
              class="absolute inset-0 w-full h-full object-cover"
              (error)="$any($event.target).style.display='none'"
            />
          </div>
          <div class="flex flex-col min-w-0 flex-1">
            <span class="text-sm font-medium text-gray-700 truncate">{{ item.data?.title || item.title }}</span>
            <span *ngIf="item.data?.skills?.[0]?.name" class="text-xs text-gray-400 truncate">{{ item.data.skills[0].name }}</span>
          </div>
          <span class="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0 whitespace-nowrap"
            [ngClass]="getContentTypeBadge(item.type).classes">
            {{ getContentTypeBadge(item.type).label | translate }}
          </span>
        </div>
      </div>
    </div>

  </nav>

  <!--
    [MOBILE SCROLL SEARCH] Barra de búsqueda predictiva fixed en móvil.
    Aparece al hacer scroll > 120px, pegada justo debajo del header (top-14 = 56px).
    Solo visible en overview (md:hidden + *ngIf con router.url).
    Al ser fixed se mantiene visible mientras el usuario sigue scrolleando,
    igual que el header de escritorio.
  -->
  <div
    *ngIf="showMobileScrollSearch && !showMobileSearchInput && (router.url.includes('overview') || router.url.includes('catalogue'))"
    class="md:hidden fixed top-14 left-0 right-0 z-[999] bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm px-4 py-2 mobile-scroll-search-bar"
    [clickOutside]="[]"
    (onClickOutside)="showPredictiveDropdown && closePredictiveDropdown()">

    <!-- Input de búsqueda móvil -->
    <div class="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full px-4 py-2">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4 text-gray-400 flex-shrink-0">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
      </svg>
      <input
        type="text"
        [value]="predictiveQuery"
        (input)="onPredictiveInput($any($event.target).value)"
        (keydown.enter)="onPredictiveEnter()"
        (keydown.escape)="closePredictiveDropdown()"
        [placeholder]="'words.would-like-to-learn' | translate"
        class="flex-1 min-w-0 bg-transparent border-none outline-none text-sm text-gray-700 placeholder-gray-400"
        autocomplete="off"
      />
      <!-- Spinner de carga -->
      <div *ngIf="isLoadingPredictive" class="flex-shrink-0">
        <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
      </div>
      <!-- Botón limpiar texto -->
      <button *ngIf="predictiveQuery.length > 0"
        (click)="onPredictiveInput('')"
        class="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-200 transition-colors">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-3 h-3">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Dropdown predictivo del buscador móvil -->
    <div *ngIf="showPredictiveDropdown"
      class="absolute left-4 right-4 top-full mt-1 bg-white shadow-xl rounded-xl z-[9999] overflow-hidden border border-gray-100">

      <!-- Hint: escribe más caracteres -->
      <div *ngIf="predictiveQuery.trim().length < 3 && predictiveQuery.trim().length > 0"
        class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
        <i class="fa-solid fa-magnifying-glass text-gray-300 text-xs"></i>
        <span>Escribe al menos 3 caracteres para buscar…</span>
      </div>

      <!-- Estado de carga -->
      <div *ngIf="isLoadingPredictive && predictiveQuery.trim().length >= 3"
        class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
        <i class="fa-solid fa-circle-notch fa-spin text-gray-400 text-xs"></i>
        <span>Buscando…</span>
      </div>

      <!-- Sin resultados -->
      <div *ngIf="!isLoadingPredictive && predictiveResults.length === 0 && predictiveQuery.trim().length >= 3"
        class="flex items-center gap-2 px-4 py-3 text-sm text-gray-400">
        <i class="fa-solid fa-search-minus text-gray-300 text-xs"></i>
        <span>Sin resultados para "{{ predictiveQuery }}"</span>
      </div>

      <!-- Lista de resultados predictivos -->
      <div *ngFor="let item of predictiveResults"
        class="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0"
        (click)="selectPredictiveResult(item)">
        <div class="relative w-10 h-8 rounded-sm flex-shrink-0 bg-gray-100 flex items-center justify-center overflow-hidden">
          <i class="fa-solid fa-book-open text-gray-400 text-sm"></i>
          <img
            *ngIf="getPredictivePicture(item)"
            [src]="getPredictivePicture(item)"
            class="absolute inset-0 w-full h-full object-cover"
            (error)="$any($event.target).style.display='none'"
          />
        </div>
        <div class="flex flex-col min-w-0 flex-1">
          <span class="text-sm font-medium text-gray-700 truncate">{{ item.data?.title || item.title }}</span>
          <span *ngIf="item.data?.skills?.[0]?.name" class="text-xs text-gray-400 truncate">{{ item.data.skills[0].name }}</span>
        </div>
        <span class="text-xs font-medium px-2 py-0.5 rounded-full flex-shrink-0 whitespace-nowrap"
          [ngClass]="getContentTypeBadge(item.type).classes">
          {{ getContentTypeBadge(item.type).label | translate }}
        </span>
      </div>
    </div>
  </div>

</div>
</ng-container>

<!--header admin -->
<ng-container *ngIf="currentJob !== 'learn'">
  <div class="content ">
    <div
      class="mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] flex items-center justify-between">
      <div class="flex items-center gap-4 md:w-full lg:w-4/5 hide-on-mobile-search">
        <img [src]="companyLogo" alt="CompanyName" class="h-8 w-auto max-w-full object-contain sm:h-8 cursor-pointer"
          [routerLink]="['/', currentJob, company?.slug]" (click)="closePlayer()">
        <!--Custom responsive md == sm  -->
        <div class='bbt-menu xl:hidden md:hidden sm:block '>
          <nav class="nav-header-sm">
            <label for='drop' class='toggle'> <span> <i class="icon icon-menu-arrow"></i></span></label>
            <input type='checkbox' id='drop' />
            <ul class='menu tab'>
              <li class="tabs">
                <ng-container *ngFor="let role of roles">
                  <div class="tab" *ngIf="!role.hidden" [routerLink]="role.routerLink" [routerLinkActive]="'active'"
                    (click)="role.customNavParams ? navigateTo(role.customNavParams) : null">
                    <span>{{ role.label | translate }}</span>
                  </div>
                </ng-container>
              </li>
            </ul>
          </nav>
        </div>
        <!--Custom XL -->
        <div class="tabs hidden xl:flex  xl:flex-row md:block xl:block gap-6 px-8">
          <ng-container *ngFor="let role of roles">
            <div class="bg-white tab items-navbar relative text-gray-700  text-sm font-medium py-1 px-0" *ngIf="!role.hidden"
              [routerLink]="role.routerLink" [routerLinkActive]="'active'"
              (click)="role.customNavParams ? navigateTo(role.customNavParams) : null">
              <span>{{ role.label | translate }}</span>
            </div>
          </ng-container>
        </div>
        <div class="hidden md:block xl:block" cdkOverlayOrigin #search="cdkOverlayOrigin">
          <msc-common-search *ngIf="currentJob === 'learn' && access.permissions.companyAccessPlatform"
            [placeholder]="'common.search' | translate" (searchEvent)="displayedSearch($event.value)">
          </msc-common-search>
        </div>
      </div>
      <!-- logo -->
      <!-- Fin Custom -->
      <div class="actions">
        <div class="flex space-x-4 " *ngIf="currentJob === 'organize'">
          <!-- person and pin vinculado con sidebar==  -->
          <msc-button icon="icon-person-add" palette="primary" type="fab" [tooltip]="'words.invite-user' | translate"
            direction="bottom" (click)="addUser()" class="hidden md:block lg:block xl:block"></msc-button>
          <msc-button icon="icon-pin-2" palette="primary" type="fab" [tooltip]="'words.pin-content' | translate"
            direction="bottom" (click)="addPinnedContentAside.onOpen()"
            class="hidden md:block lg:block xl:block"></msc-button>
        </div>


        <!-- Menú Perfil -->
        <div class="relative item-perfile">
          <button id="profile-btn" class="flex items-center space-x-2 ">
            <msc-common-avatar class="avatar-admin"
              (click)="profileOpen = true" cdkOverlayOrigin #profile="cdkOverlayOrigin"
              [label]="me?.name" [pictureURL]="me?.picture ? (me?.picture + '?size=64') : null">
            </msc-common-avatar>
            <div class="flex flex-row items-center">
              <div class="hidden md:block">
                <div class="text-left">
                  <p class="text-sm font-medium text-gray-700">{{ shortName }}</p>
                  <!--  <p class="text-xs text-gray-500 hidden">{{'words.level' | translate}} 7</p>-->
                </div>
              </div>
              <i class="fas fa-chevron-down text-gray-400 ml-2 w-4 h-4 hidden md:block text-sm"></i>
            </div>
          </button>

          <!-- Menú desplegable de perfil (Desktop) -->
          <div id="profile-menu"
            class="absolute right-0 mt-2 w-56 bg-white shadow-xl rounded-lg  hidden z-[999999] border border-gray-100" style="left: -2rem;">
            <!-- Header del perfil -->
            <div class="px-4 py-3 border-b border-gray-100 bg-gray-50 rounded-t-lg">
              <p class="text-sm font-medium text-gray-700">{{ shortName }}</p>
              <p class="text-xs text-gray-500 truncate">{{me?.email}}</p>
            </div>

            <!--sec-1 mis cursos, academy  -->
            <!-- Sección 1 
            <div class="px-2 py-1">

              <a [routerLink]="['/learn', company?.slug, 'contents']" (click)="closePlayer()"
                class="block py-2 text-gray-700 hover:bg-gray-100"><i
                  class="fas fa-graduation-cap text-gray-500 text-xs w-4"></i> {{"words.my-courses" | translate}}</a>

              <a [routerLink]="['/learn', company?.slug, 'academy', 'details']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-user-graduate text-gray-500 text-xs w-4"></i>
                {{'words.academy-profile' | translate}}
              </a>

              <a [routerLink]="['/learn', company?.slug, 'onementor']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"
                *ngIf="hasOneMentorEnabled">
                <i class="fas fa-rocket text-gray-500 text-xs w-4"></i> {{'words.boots-your-profile' | translate}}</a>
            </div>-->

            <!-- Sección 2 -->
            <div class=" px-2 py-1">
              <!-- Cambiar de rol -->
              <div class="relative group">
                <div [ngClass]="{
                    'pointer-events-none': !canNavigate,
                    'invisibleOptions': !showChangeUserRole
                  }"
                  class="items-navbar flex items-center justify-between px-3 py-1.5 text-gray-500 text-sm rounded-md cursor-pointer transition-colors duration-150"
                  id="change-role-btn">
                  <div class="flex items-center gap-2">
                    <i class="icon-credit-card icon text-base w-4 flex justify-center"></i>
                    <span class="text-gray-500">{{'words.change-rol' | translate}}</span>
                  </div>
                  <i class="fas fa-chevron-right text-xs flex justify-center"></i>
                </div>
                <div
                  class="absolute right-full top-0 mr-1 w-56 bg-white shadow-lg rounded-md py-2 hidden  group-focus-within:block z-[10000] border border-gray-100 dropdown-menu"
                  id="change-role-menu">
                  <div class="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                    {{'words.select-rol'
                    | translate}}</div>
                  <div _ngcontent-pug-c114="" class="border-t border-gray-100 mx-3"></div>
                  <ul class='menu tab'>
                    <li>
                      <ng-container *ngFor="let role of roles">
                        <div class="items-navbar block px-4 py-1.5 text-gray-500 text-sm cursor-pointer"
                          *ngIf="!role.hidden" [routerLink]="role.routerLink" [routerLinkActive]="'active'"
                          (click)="role.customNavParams ? navigateTo(role.customNavParams) : null">
                          <span class="text-gray-500">{{ role.label | translate }}</span>
                        </div>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Cambiar de empresa -->
              <div class="relative group" [ngClass]="{
                    'pointer-events-none': !canNavigate,
                    'invisibleOptions': !showChangeUserCompany
                  }">
                <div
                  class="items-navbar flex items-center justify-between px-3 py-1.5 text-gray-500 text-sm rounded-md cursor-pointer transition-colors duration-150"
                  id="change-company-btn">
                  <div class="flex items-center gap-2">
                    <i class="icon icon-layers text-base w-4 flex justify-center"></i>
                    <span class="text-gray-500">{{'words.change-company' | translate}}</span>
                  </div>
                  <i class="fas fa-chevron-right text-xs"></i>
                </div>

                <div
                  class="absolute right-full top-0 mr-1 min-w-[250px] bg-white shadow-lg rounded-md py-2 hidden  group-focus-within:block z-[10000] border border-gray-100 dropdown-menu"
                  id="change-company-menu">
                  <div class="px-3 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">
                    {{'studio.section-content.select-company' | translate}}
                  </div>

                  <div class="border-t border-gray-100 mx-3"></div>

                  <!-- Buscador -->
                  <div class="px-3 py-2" (click)="$event.stopPropagation()">
                    <div
                      class="w-full flex items-center border border-gray-200 rounded-md shadow-sm bg-white overflow-hidden">
                      <input type="text" [placeholder]="'placeholder.search' | translate"
                        class="flex-grow px-2 py-1 text-sm font-[400] focus:outline-none" [(ngModel)]="companySearch"
                        (ngModelChange)="filterAvailableCompanies($event)" />
                      <button class="p-2">
                        <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Empresas -->
                  <div id="companiesList" class="max-h-60 overflow-y-auto">
                    <div class="company-item flex" *ngFor="let availableCompany of availableCompanies"
                      [class.active]="availableCompany.id === company.id"
                      (click)="onSelectCompany(availableCompany); companiesPickerOpen = false">
                      <i *ngIf="!availableCompany.logo" class="icon icon-company-building"></i>
                      <div class="company-item__logo" *ngIf="availableCompany.logo"
                        [style.backgroundImage]="'url(' + availableCompany.logo + '?size=512' + ')'"></div>
                      <div>
                        <a class="items-navbar block px-4 py-1.5 text-gray-500 text-sm">{{ availableCompany.title |
                          translate }}</a>
                        <!--<small class="text-black-300" [innerHTML]="availableCompany.subtitle | translate"></small>-->
                      </div>
                      <div class="company-item__state" *ngIf="availableCompany.id === company.id">
                        <i class=" fa-solid fa-check text-green-500 text-xs"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Sec-3 grupos, app... -->
            <!-- 
            <div class="border-t border-gray-100 mx-3"></div>
            <div class="px-2 py-1">
              <a [routerLink]="['/learn', company?.slug, 'communities']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-users text-gray-500 text-xs w-4"></i> {{'words.groups' | translate}}</a>
              <a [routerLink]="['/learn', company?.slug, 'integrations']" (click)="closePlayer()"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-window-restore text-gray-500 text-xs w-4"></i> {{'words.my-applications' |
                translate}}</a>
              <a href="#"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-star text-gray-500 text-xs w-4"></i> {{'words.favorites' | translate}}</a>
            </div>-->

            <!-- Sección 4 -->
            <div class="border-t border-gray-100 mx-3"></div>
            <div class="px-2 py-1 pb-3">

              <a routerLink="/account/settings"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="icon icon-settings text-gray-500 text-base w-4 flex justify-center"></i> {{'words.settings' | translate}}</a>
              <!--<a href="#"
                class="block px-3 py-1.5 text-gray-500 items-navbar text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-question-circle text-gray-500 text-xs w-4"></i> {{'header.profile.help' |
                translate}}</a>-->
              <a (click)="logout()"
                class="block px-3 py-1.5 text-red-500 hover:bg-red-50 text-sm rounded-md transition-colors duration-150 flex items-center gap-2"><i
                  class="fas fa-sign-out-alt text-red-500 text-xs w-4"></i> {{'auth.logout' | translate}}</a>
            </div>
          </div>

          <!-- Menú de perfil responsive (móvil)
          <div id="mobile-menu-perfile"
               class="hidden md:hidden fixed inset-0 bg-white z-50 p-6 flex flex-col">
            <button id="close-profile-menu" class="absolute top-3 right-3 text-gray-600 text-2xl">
              <i class="fa-solid fa-xmark"></i>
            </button>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Mi aprendizaje</a>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Mi perfil académico</a>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Impulsa tu perfil</a>
            <hr>
            <div class="relative flex items-center lg:px-4 lg:py-1 hover:rounded-[10px] hover:bg-gray-100">
              <button id="company-btn" class="block py-2 text-gray-700 hover:bg-gray-100 basis-[90%] text-start">
                Cambiar de empresa
              </button>
              <i class="fas fa-chevron-right text-gray-600 ml-1 text-sm basis-[10%] text-end"></i>
              <div id="company-menu"
                   class="absolute left-0 mt-2 w-40 bg-white shadow-md rounded-lg py-2 hidden z-[10000]">
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 1</a>
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 2</a>
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 3</a>
              </div>
            </div>
            <div class="relative flex items-center lg:px-4 lg:py-1 hover:rounded-[10px] hover:bg-gray-100">
              <button id="roles-btn" class="block py-2 text-gray-700 hover:bg-gray-100 basis-[90%] text-start">
                Cambiar de rol
              </button>
              <i class="fas fa-chevron-right text-gray-600 ml-1 text-sm basis-[10%] text-end"></i>
              <div id="roles-menu"
                   class="absolute left-0 mt-2 w-40 bg-white shadow-md rounded-lg py-2 hidden z-[10000]">
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 1</a>
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 2</a>
                <a href="#" class="block px-4 py-1 text-gray-700 hover:bg-gray-100 text-sm">Opción 3</a>
              </div>
            </div>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Grupos</a>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Mis aplicaciones</a>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Favoritos</a>
            <hr>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Configuración de cuenta</a>
            <a href="#" class="block py-2 text-gray-700 hover:bg-gray-100">Ayuda</a>
            <a href="#" class="block py-2 text-red-500 hover:bg-gray-100">Salir</a>
          </div>-->
        </div>
        <!--profile anterior -->
        <div class="profile" style="display:none !important;">
          <!-- mensaje vinculado con sidebar==  
            <div [tooltip]="'words.conversation' | translate" direction="bottom" >
                <msc-button class="msc-button--large" type="fab" icon="icon-email-1" [routerLink]="['/conversation']">
                </msc-button>
            </div>-->
          <!--
          <div [tooltip]="'words.profile' | translate" direction="bottom" >
            <msc-common-avatar (click)="profileOpen = true" cdkOverlayOrigin #profile="cdkOverlayOrigin"
              [label]="me?.name" [pictureURL]="me?.picture ? (me?.picture + '?size=64') : null">
            </msc-common-avatar>
          </div>-->
        </div>
      </div>
    </div>
  </div>

  <msc-appcues *ngIf="displays.appcues" (onBack)="displayed('appcues'); displayed('help', true)"
    (onClose)="displayed('help')" [currentJob]="currentJob"></msc-appcues>
  <msc-shared-aside-extension #addPinnedContentAside></msc-shared-aside-extension>
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" [cdkConnectedOverlayOrigin]="profile"
    [cdkConnectedOverlayOpen]="profileOpen" (backdropClick)="profileOpen = false">



    <ul class="profile-list" style="display:none !important;">
      <li class="flex space-x-2">
        <msc-common-avatar [label]="me?.name" [pictureURL]="me?.picture ? (me?.picture + '?size=64') : null">
        </msc-common-avatar>
        <div class="flex flex-col">
          <span>{{ shortName }}</span>
          <small>{{me?.email}}</small>
        </div>
      </li>
      <li *ngIf="showChangeUserCompany" class="menu-item relative" (click)="companiesPickerOpen = true" tabindex="0">
        <span>{{ 'header.profile.change-workspace' | translate }}</span>
        <i class="ml-auto icon icon-arrow-ios-right text-secondary-500"></i>
        <div class="company-list">
          <div class="company-item" *ngFor="let availableCompany of availableCompanies"
            [class.active]="availableCompany.id === company.id"
            (click)="onSelectCompany(availableCompany); companiesPickerOpen = false">
            <i *ngIf="!availableCompany.logo" class="icon icon-company-building"></i>
            <div class="company-item__logo" *ngIf="availableCompany.logo"
              [style.backgroundImage]="'url(' + availableCompany.logo + '?size=512' + ')'"></div>
            <div class="company-item__label">
              <span>{{ availableCompany.title | translate }}</span>
              <small class="text-black-300" [innerHTML]="availableCompany.subtitle | translate"></small>
            </div>
            <div class="company-item__state" *ngIf="availableCompany.id === company.id">
              <i class="icon icon-checkmark"></i>
            </div>
          </div>
        </div>
      </li>
      <li class="menu-item" routerLink="/account/settings" (click)="profileOpen = false">
        <span>{{ 'header.profile.account-settings' | translate }}</span>
      </li>
      <!--
        <li>
            <ul>
                <li class="menu-item" tabindex="1">
  
                    <i class="icon icon-question-mark-circle"></i>
                    <span>{{'header.profile.help' | translate }}</span>
                    <i class="ml-auto icon icon-arrow-ios-right text-secondary-500"></i>
                    <ul class="help-list">
  
                        <li (click)="support()" [attr.id]="currentJob !== 'learn' ? 'chat-help-hook' : 'chat'">
                            <i
                                class="icon {{currentJob !== 'learn' ? 'icon-question-mark-circle' : 'icon-message-circle-1'}} text-secondary-500"></i>
                            <div>
                                <span>
                                    {{ (currentJob !== 'learn' ? 'words.support.manage' : 'words.support.learn') |
                                    translate }}
                                </span>
  
                                <small>
                                    {{ (currentJob !== 'learn' ? 'words.support.description.manage' :
                                    'words.support.description.learn') | translate }}
                                </small>
                            </div>
                        </li>
                        <li (click)="documentation()">
                            <i class="icon icon-layers-1 text-secondary-500"></i>
                            <div>
                                <span>
                                    {{ 'words.documentation' | translate }}
                                </span>
                                <small>
                                    {{ 'words.documentation.description' | translate }}
                                </small>
                            </div>
                        </li>
                        <li (click)="displayed('appcues')"
                            *ngIf="booted('appcues') && currentJob === 'learn' && access.permissions.companyAccessPlatform">
                            <i class="icon icon-book-open text-secondary-500"></i>
                            <div>
                                <span>
                                    {{ 'words.guides' | translate }}
                                </span>
                                <small>
                                    {{ 'words.guides.description' | translate }}
                                </small>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>-->
      <li class="menu-item" (click)="logout()">
        <span>{{ 'header.profile.logout' | translate }}</span>
      </li>
    </ul>
  </ng-template>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'" [cdkConnectedOverlayOrigin]="search"
    [cdkConnectedOverlayOpen]="searchOpen" (backdropClick)="searchOpen = false">
    <ul class="search-container">
      <li class="search-entry border-b" (click)="navigate('catalogue', true); searchOpen = false">
        <div class="tag">
          <div class="tag__text">
            {{ 'words.catalogue' | translate }}
          </div>
        </div>
        <span>{{ 'header.search.catalogue' | translate:{value: displayedQuery} }}</span>
      </li>
      <li class="search-entry" (click)="navigate('contents', true); searchOpen = false">
        <div class="tag tag--red">
          <div class="tag__text">
            {{ 'words.my-courses' | translate }}
          </div>
        </div>
        <span>{{ 'header.search.contents' | translate:{value: displayedQuery} }}</span>
      </li>
    </ul>
  </ng-template>
</ng-container>